import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isCommentTooLongError, showCommentTooLongAlert } from '../../../utils/commentErrorUtils';
import { Box } from 'foundations-components/transitional/components/Box';
import { CommentsContext } from '../../../contexts/CommentsContext';
import { CommentRTE } from './CommentRTE';
import { getEditCommentStorageKey } from '../../../constants/LocalStorageConstants';
import { useLocalStorageState } from '../../../utils/useLocalStorageState';
import debounce from 'react-utils/debounce';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditCommentEditor = props => {
  const {
    comment,
    onCancelCallback,
    onSubmitCallback,
    editSubmitBtnText
  } = props;
  const editCommentStorageKey = getEditCommentStorageKey({
    objectType: comment.objectType,
    objectId: comment.objectId,
    commentId: comment.id
  });
  const [editCommentDraft, setEditCommentDraft] = useLocalStorageState({
    key: editCommentStorageKey,
    initialValue: comment.message
  });
  const {
    handleUpdateComment,
    onError
  } = useContext(CommentsContext);
  const handleSubmitBtnClick = (message, atMentionedUserIds) => {
    handleUpdateComment({
      commentId: comment.id,
      message,
      atMentionedUserIds
    }).then(() => {
      onSubmitCallback();
      setEditCommentDraft(undefined);
    }).catch(error => {
      if (isCommentTooLongError(error)) {
        showCommentTooLongAlert();
      } else {
        onError( /*#__PURE__*/_jsx(FormattedMessage, {
          message: "objectCommentsThread.comments.alerts.updateError"
        }));
      }
    });
  };
  const handleCancelBtnClick = () => {
    onCancelCallback();
    setEditCommentDraft(undefined);
  };
  const handleChange = debounce(html => {
    if (html !== editCommentDraft) {
      setEditCommentDraft(html);
    }
  }, 300);
  return /*#__PURE__*/_jsx(Box, {
    grow: 1,
    basis: "100%",
    "data-test-id": "comments-editCommentContainer",
    children: /*#__PURE__*/_jsx(CommentRTE, {
      value: comment.message,
      draftValue: editCommentDraft,
      onSubmitClick: handleSubmitBtnClick,
      onCancelClick: handleCancelBtnClick,
      onChange: handleChange,
      submitBtnText: editSubmitBtnText || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "objectCommentsThread.comments.updateBtn"
      }),
      autoFocus: true
    })
  });
};